import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import {
  VipDiscountsSellingActions,
  VipDiscountsSellingSelectors,
} from '../../store/vip-discounts-selling.slice';

@Component({
  selector: 'app-vip-discounts-given',
  templateUrl: './vip-discounts-given.component.html',
  styleUrls: ['./vip-discounts-given.component.scss'],
})
export class VipDiscountsGivenComponent implements OnInit, OnDestroy {
  subs = new SubSink();
  selectedDiscounts!: Array<string>;

  constructor(private store: Store) {}

  isAllGivenMerchantsSelected$ = this.store.select(
    VipDiscountsSellingSelectors.isAllGivenMerchantsSelected
  );

  discountsGiven$ = this.store.select(
    VipDiscountsSellingSelectors.selectDiscountsGiven
  );

  ngOnInit(): void {
    this.store.dispatch(
      VipDiscountsSellingActions.loadDiscountsGiven.trigger()
    );
    this.subs.add(
      this.store
        .select(
          VipDiscountsSellingSelectors.selectSelectedGivenProductsForGroupOperation
        )
        .subscribe((discounts) => (this.selectedDiscounts = discounts))
    );
  }

  deleteSelectedItems() {
    this.store.dispatch(
      VipDiscountsSellingActions.deleteSelectedDiscounts.trigger({
        selectedDiscounts: this.selectedDiscounts,
      })
    );
  }

  ngOnDestroy(): void {
    this.store.dispatch(VipDiscountsSellingActions.clearIndexes.trigger());
    this.subs.unsubscribe();
  }
}
